import { Button } from '../button';
import React from "react";

// Define interface for props
interface VoucherErrorPopUpProps {
  errorCode?: string;
}

export const VoucherErrorPopUp: React.FC<VoucherErrorPopUpProps> = ({ errorCode }) => {
  return (
    <div className="flex justify-center items-center w-full ">
      <div className="flex py-24 container justify-center items-center flex-col gap-4  ">

        {/* Logo */}
        {/* <img src="/images/sky_logo.png" alt="Sky Logo" /> */}
        <svg width="138" height="79" viewBox="0 0 138 79" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M42.1924 52.4911C40.7919 58.6356 36.9403 64.2533 25.7356 64.4289H1.22551C0.525218 64.4289 0 63.7267 0 63.0244L1.75072 55.1244C1.9258 54.5978 2.45101 54.2467 2.97623 54.2467H25.7356C29.4121 54.2467 30.4626 53.3689 30.8127 52.14C31.1629 51.0867 30.6377 49.8578 27.8365 48.8044L16.1067 44.0644C11.5548 42.3089 5.42724 38.9733 7.17796 31.2489C8.57854 25.28 12.9554 19.6622 23.8098 19.6622H46.7443C47.4446 19.6622 47.9698 20.3644 47.9698 21.0667L46.2191 28.9667C46.044 29.4933 45.5188 29.8444 44.9936 29.8444H22.5843C19.6081 29.8444 18.7327 30.7222 18.7327 31.7756C18.5577 32.8289 19.7832 33.7067 22.9345 35.1111L33.6139 39.5C39.0411 41.6067 43.9432 44.7667 42.1924 52.4911ZM68.8034 0H59.5246C58.9994 0 58.4742 0.351111 58.2991 0.877778L44.2933 62.8489C44.1182 63.5511 44.6434 64.2533 45.5188 64.2533H54.7976C55.3229 64.2533 55.8481 63.9022 56.0231 63.3756L70.0289 1.22889C70.204 0.702224 69.6788 0 68.8034 0ZM136.732 19.6622H126.227C125.877 19.6622 125.527 19.8378 125.352 20.0133L108.37 38.6222L96.9901 20.1889C96.815 19.8378 96.2898 19.6622 95.9396 19.6622H91.913H85.7854H81.4086C81.0585 19.6622 80.7083 19.8378 80.5333 20.0133L61.1002 41.6067L74.7559 63.7267C74.931 64.0778 75.4562 64.2533 75.8063 64.2533H86.6608C87.5362 64.2533 88.2365 63.2 87.7112 62.4978L74.7559 41.6067L88.2365 26.6844L101.717 48.6289L95.2394 77.5956C95.0643 78.2978 95.5895 79 96.4649 79H105.394C105.919 79 106.444 78.6489 106.619 78.1222L113.272 48.6289L137.957 21.5933C138.132 20.8911 137.782 19.6622 136.732 19.6622Z" fill="#00013A"/>
          </svg>

        {/* Heading */}
        <div className="w-3/4 lg:w-1/2 p-3 flex flex-col gap-2 justify-center text-center ">
          <h3 className="sky-h2-black md:sky-h3-black text-primary-mid-night ">
             This promo code currently has a redemption in progress
          </h3>

          {/* Error Message */}
          <p className="sky-h5 md:sky-h6 text-gray-700 mt-2">
             This may be another open browser or cart in progress. If not, please contact us for more information.
          </p>
        </div>

        {/* Button */}
        <Button
          variant="primary"
          type="button"
          onClick={() => window.location.href = '/'}
          className={
            'sky-button--primary-pure' +
            ' sky-button mx-0 px-10 py-3 '
          }
          colorMode="pure"
          disabled={false}
        >
          <span className="font-extrabold">#</span>Return to Step1
        </Button>
      </div>
    </div>
  );
};

